import React, { FunctionComponent } from 'react';
import Faceless from '../../assets/images/faceless.webp';
import { InternalLink } from '../internal-link/internal-link';
import styles from './contact-box.module.scss';

export interface IContactBoxProps {
  boldPlaceholder: string;
  placeholderDescription?: string;
  buttonCTA?: string;
  addAnonimPerson?: boolean;
}

export const ContactBox: FunctionComponent<IContactBoxProps> = props => {
  const {
    boldPlaceholder,
    placeholderDescription,
    buttonCTA,
    addAnonimPerson
  } = props;

  return (
    <>
      {addAnonimPerson ? (
        <img
          src={Faceless}
          className={styles.anonimPerson}
          alt="Faceless person"
        />
      ) : null}

      <div className={styles.contactWrapper}>
        <div
          dangerouslySetInnerHTML={{ __html: boldPlaceholder }}
          className={styles.boldPlaceholder}
        />

        {placeholderDescription ? (
          <div className={styles.placeholderDescription}>
            {placeholderDescription}
          </div>
        ) : null}

        {buttonCTA ? (
          <InternalLink url={'/contact'} className={styles.buttonCTA}>
            <i className={`material-icons`}>{'mail_outline'}</i>
            {buttonCTA}
          </InternalLink>
        ) : null}
      </div>
    </>
  );
};
